import {
  IntegrationChannelType,
  IntegrationType,
  IntegrationViewFragment,
} from 'generated/graphql';

interface GetIsUserOrAccountIntegrationAlreadyConnected {
  connectedIntegrations: IntegrationViewFragment[];
  integrationType: IntegrationType;
  channelType: IntegrationChannelType;
}

export const getIsUserOrAccountIntegrationAlreadyConnected = ({
  connectedIntegrations,
  integrationType,
  channelType,
}: GetIsUserOrAccountIntegrationAlreadyConnected) => {
  if (
    integrationType !== IntegrationType.User &&
    integrationType !== IntegrationType.Account
  ) {
    return {
      isUserOrAccountIntegrationConnected: false,
      isSameSource: false,
      connectedIntegration: null,
    };
  }

  const connectedUserOrAccountIntegration = connectedIntegrations.find(
    (integration) =>
      integration.integrationType === integrationType && integration.isActive,
  );

  return {
    isUserOrAccountIntegrationConnected: !!connectedUserOrAccountIntegration,
    isSameSource: connectedUserOrAccountIntegration
      ? connectedUserOrAccountIntegration.channel.type === channelType
      : false,
    connectedIntegration: connectedUserOrAccountIntegration,
  };
};
